import * as React from "react";
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import RemoveButton from "./RemoveButton";
import { cn } from "@/lib/utils";

/**
 * Reusable card wrapper component for array items (experience, education, projects, etc.)
 * Uses shadcn/ui Card components for modern design
 * @param {string} title - Card title (e.g., "Experience 1")
 * @param {number} index - Item index (for numbering and aria labels)
 * @param {Function} onRemove - Remove handler: () => void
 * @param {ReactNode} children - Card content (form fields)
 * @param {string} className - Additional CSS classes for the card
 */
const ArrayFieldCard = React.forwardRef(({
  title,
  index,
  onRemove,
  children,
  className = "",
}, ref) => {
  return (
    <Card ref={ref} className={cn("mb-4", className)}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
        <CardTitle className="text-lg font-semibold">
          {title || `Item ${index + 1}`}
        </CardTitle>
        <RemoveButton 
          onClick={onRemove} 
          ariaLabel={`Remove ${title || `item ${index + 1}`}`}
        />
      </CardHeader>
      <CardContent className="space-y-4">
        {children}
      </CardContent>
    </Card>
  );
});

ArrayFieldCard.displayName = "ArrayFieldCard";

export default ArrayFieldCard;
